<template>
  <ScrollTop v-if="showScrollTop" />
  <div class="englobe-params">
    <div class="params-row top">
      <FiltersMenu
        :active-filters="activeFilters"
        :is-loading="!store.filters"
        @remove-filter="removeFilterItem"
        @reset-all-filters="resetAllFilters"
      >
        <SelectMultipleCounter
          v-for="(value, key) in filtersNames"
          :key="key"
          :filter="key"
          :items="store.filters[key]"
          :active-filters="selectedFilters[key]"
          has-search
          @add-filter-item="addFilterItem"
          @remove-filter-item="removeFilterItem"
          @reset-filter="resetFilter"
        >
          {{ value }}
        </SelectMultipleCounter>
      </FiltersMenu>
      <FollawedRadioButtons
        v-if="
          route.name === 'Parties Prenantes - Ranking List' ||
          route.name === 'Parties Prenantes - Follawed'
        "
        all-match-route="/stakeholders/ranking"
        follawed-route="/stakeholders/ranking/follawed"
      />
    </div>

    <div class="params-row">
      <RouterRadioButtons :options="routeOptions"></RouterRadioButtons>

      <TotalMatched
        v-if="isRankingView"
        :item-count="store.authorsCountStakeholder"
      />

      <div class="page-settings">
        <DropdownMenu
          v-model="selectedSorterOption"
          :options="sortersOptions"
          label="Trier par :"
        />

        <DropdownMenu
          v-if="isRankingView"
          v-model="selectedLimitOption"
          :options="limitOptions"
          label="Auteurs par page :"
        />
      </div>
    </div>

    <div class="params-row"></div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { storeToRefs } from "pinia";
import FiltersMenu from "@follaw-fr/components/filter-menu/organisms/FiltersMenu.vue";
import FollawedRadioButtons from "@/follaw-fr/components/reusable/atoms/FollawedRouterRadioButtons.vue";
import RouterRadioButtons from "@follaw-fr/components/reusable/molecules/RouterRadioButtons.vue";
import SelectMultipleCounter from "@follaw-fr/components/filter-menu/molecules/SelectMultipleCounter.vue";
import ScrollTop from "@follaw-fr/components/reusable/atoms/ScrollTop.vue";
import TotalMatched from "@follaw-fr/components/reusable/atoms/TotalMatched.vue";
import DropdownMenu from "@follaw-fr/components/reusable/atoms/DropdownMenu.vue";
import { useDropdown } from "@follaw-fr/composables/useDropdown";
import { useStakeholdersStore } from "@follaw-fr/stores/social-media/stakeholders";

const store = useStakeholdersStore();
const route = useRoute();
const { selectedFilters } = storeToRefs(store);

const filtersNames = {
  group: "Groupe",
  major_stakeholder: "Grande Partie Prenante",
  stakeholder: "Partie Prenante",
  level: "Niveau",
  circo_name: "Localité",
};

const baseRoute = `/stakeholders/`;
const routeOptions = [
  { label: "Classement", value: `${baseRoute}ranking` },
  { label: "Cartographie Politique", value: `${baseRoute}political` },
  { label: "Cartographie Sociétale", value: `${baseRoute}social` },
];

const { options: sortersOptions, selectedValue: selectedSorterOption } =
  useDropdown({
    options: {
      number_of_publications: "Nombre de publications",
      number_of_impressions: "Nombre d'impressions",
    },
    selectedFilters,
    filterKey: "sort_field",
    onChange: () => getAuthorsStakeholdersList(),
  });

const { options: limitOptions, selectedValue: selectedLimitOption } =
  useDropdown({
    options: { 10: "10", 20: "20", 50: "50", 200: "200" },
    selectedFilters,
    filterKey: "size",
    onChange: () => {
      selectedFilters.value.from = 0; // Reset pagination
      getAuthorsStakeholdersList();
    },
  });

const isRankingView = computed(() =>
  ["Parties Prenantes - Ranking List", "Parties Prenantes - Follawed"].includes(
    route.name
  )
);

const activeFilters = computed(() => {
  const filtersArray = [];
  Object.keys(filtersNames).forEach((key) => {
    selectedFilters.value[key]?.forEach((filter) => {
      filtersArray.push({ filter: key, item: filter });
    });
  });
  return filtersArray;
});

const showScrollTop = computed(() => selectedFilters.value.size > 20);

const addFilterItem = (event) => {
  const targetFilters = selectedFilters.value[event.filter] || [];
  selectedFilters.value = {
    ...selectedFilters.value,
    [event.filter]: [...targetFilters, event.item],
  };
  getAuthorsStakeholdersList();
};

const removeFilterItem = (event) => {
  let targetFilters = selectedFilters.value[event.filter] || [];

  targetFilters = targetFilters.filter((el) => el !== event.item);

  if (targetFilters.length === 0) {
    delete selectedFilters.value[event.filter];
  } else {
    selectedFilters.value = {
      ...selectedFilters.value,
      [event.filter]: targetFilters,
    };
  }
  getAuthorsStakeholdersList();
};

const resetFilter = (event) => {
  delete selectedFilters.value[event];
  getAuthorsStakeholdersList();
};

const resetAllFilters = () => {
  store.resetFilters();
  getAuthorsStakeholdersList();
};

const getAuthorsStakeholdersList = async () => {
  selectedFilters.value.from = 0;

  if (isRankingView.value) {
    await store.getAuthorsStakeholdersList();
  } else if (route.name === "Parties Prenantes - Cartographie Politique") {
    await store.fetchPoliticalMapping();
  } else if (route.name === "Parties Prenantes - Cartographie Sociétale") {
    await store.fetchSocietalMapping();
  }
};
</script>

<style lang="scss" scoped>
.select-multiple-wrapper {
  margin-left: 10px;
}

.sort-and-limit {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.buttons-wrapper {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
</style>
